// document.addEventListener('DOMContentLoaded', () => {
//     console.log('kom-js caricato');
// });

const komCard = document.querySelector('#kom-card-nl');

// ID form Klaviyo per lingua (da <html lang>); fallback italiano
const komNlForms = {
  it: 'S6XKrJ',
  de: 'Upmt5i',
  fr: 'WaAAxA',
};

if (komCard) {
  komCard.addEventListener('click', function (event) {
    event.preventDefault();
    const lang = document.documentElement.lang.slice(0, 2);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', komNlForms[lang] || komNlForms.it]);
    // console.log('link-premuto')
  });
}

